/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-17 08:57:26
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-17 09:02:11
 */
/**
 * 第三方商城 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来
const index = {
    // 商品列表
    good(params) {
        return axios.get("/home/tongbu/good", { params, params });
    },
    // 商品详情
    gooddetail(params) {
        return axios.get("/home/tongbu/gooddetail", { params, params });
    },
    // 默认收货地址
    defaultaddress(params) {
        return axios.get("/home/user/defaultaddress", { params, params });
    },
    // 创建订单
    createorder(params) {
        return axios.post("/home/tongbu/createorder", qs.stringify(params));
    },
};
// 导出接口
export default index;
